<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" (click)="goBack()"></i>

        <span class="my-auto f16 fw-bold me-2"> داشبورد سفرهای اداری </span>

    </div>

</div>

<form class="rtl  w-100 row gx-2 gy-2 mt-2 p-2" [formGroup]="searchModel">

    <div class="col-12 col-md-3 position-relative">

        <label> حوزه خدمت </label>

        <select class="form-select text-center" formControlName="iMobileDomain">

            <option value="-1"> انتخاب کنید </option>

            <option *ngFor="let item of list_Domain" value="{{item.iMobileDomain}}">{{item.strComment}}</option>

        </select>

    </div>

    <div class="col-12 col-md-1 d-flex justify-content-end">

        <button class="btn w-100 btn-primary" (click)="getAllCharts()"> جستجو </button>

    </div>

</form>

<main class="p-2">

    <div class="border border-2 p-2 d-flex justify-content-around flex-wrap mt-4">

        <div class="col-12 justify-content-around d-flex row chart2 mb-5 rounded shadow mb-3">
    
            <p class="text-center f18 "> تعداد خودرو به تفکیک حوزه خدمت  </p>
    
            <canvas id="myChart1" style="max-height: 350px !important;"></canvas>
    
        </div>
    
        <div class="col-12 justify-content-around d-flex row chart2 mb-5 rounded shadow mb-3">
    
            <p class="text-center f18 "> تعداد سفر به تفکیک حوزه خدمت  </p>
    
            <canvas id="myChart2" style="max-height: 350px !important;"></canvas>
    
        </div>

        <div class="col-12 justify-content-around d-flex row chart2 mb-5 rounded shadow mb-3">
    
            <p class="text-center f18 "> تعداد سفر به تفکیک جایگاه سازمانی  </p>
    
            <canvas id="myChart3" style="max-height: 350px !important;"></canvas>
    
        </div>

        <div class="col-12 justify-content-around d-flex row chart2 mb-5 rounded shadow mb-3">
    
            <p class="text-center f18 "> تعداد سفر به تفکیک راننده در ماه گذشته </p>
    
            <canvas id="myChart4" style="max-height: 350px !important;"></canvas>
    
        </div>

        <div class="col-12 justify-content-around d-flex row chart2 mb-5 rounded shadow mb-3">
    
            <p class="text-center f18 "> تعداد سفر به تفکیک نوع خودرو  </p>
    
            <canvas id="myChart4_1" style="max-height: 350px !important;"></canvas>
    
        </div>

        <div class="col-12 justify-content-around d-flex row chart2 mb-5 rounded shadow mb-3">
    
            <p class="text-center f18 "> تعداد سفر به تفکیک پرسنل </p>
    
            <canvas id="myChart5" style="max-height: 350px !important;"></canvas>
    
        </div>
        
        <div class="col-12 justify-content-around d-flex row chart2 mb-5 rounded shadow mb-3">
    
            <p class="text-center f18 "> تعداد سفر روزانه </p>
    
            <canvas id="myChart6" style="max-height: 350px !important;"></canvas>
    
        </div>

        <div class="col-12 justify-content-around d-flex row chart2 mb-5 rounded shadow mb-3">
    
            <p class="text-center f18 "> پراکندگی سفر در شبانه روز </p>
    
            <canvas id="myChart7" style="max-height: 350px !important;"></canvas>
    
        </div>

        <div class="col-12 p-2 border border-2 rounded shadow" style="height: 600px;">

            <p class="text-center f18 bg-secondary p-2 rounded text-white "> پراکندی مبدا سفر </p>

            <div id="map1" class="fixed-mapCluster">

                <div class="position-absolute" id="map_tooltip" data-bs-html="true">

                </div>

            </div>

        </div>

        <div class="col-12 p-2 border border-2 rounded shadow" style="height: 600px;">

            <p class="text-center f18 bg-secondary p-2 rounded text-white "> پراکندی مقصد سفر </p>

            <div id="map2" class="fixed-mapCluster">

                <div class="position-absolute" id="map_tooltip" data-bs-html="true">

                </div>

            </div>

        </div>
    
    </div>

</main>
